export default "__VITE_ASSET__Bz3BTC8I__"